export default {
  methods: {
    debug (event) {
      console.log(event)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/debug.js